import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-product-tag',
  imports: [CommonModule],
  templateUrl: './product-tag.component.html',
  styleUrl: './product-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTagComponent {
  isInteractive = input(false);
  label = input.required();

  click = output();
}
